import $$ from 'cmn-utils'

const baseUrl = "/api/pay/device-service-charge/";
export default {
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    wxpay:{
        createPrepay: (params) => {
            return $$.post(baseUrl + 'wxpay/create-prepay', params)
        },
    }
}